module.exports = __webpack_public_path__ + "img/Country-Insights-Students.892655dc.jpg";